import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { dealMessagesApi, rentalMessagesApi } from '@rentflowdev/api'

import { getRealtimeSocket } from './realtime-socket'

interface DealMessageEvent {
	messageId: string
	dealId: string
	channel: string
	preview?: string
}

// Подписывается на realtime-события сделки и сбрасывает RTK Query кеш сообщений,
// чтобы UI перетянул свежий список. Optimistic apply сделан в send-mutation отдельно.
export function useRealtimeDeal(
	dealId: string | undefined,
	// A rental shows the same conversation through its own endpoint. Without
	// this the deal page updated live and the rental page did not, for the
	// very same incoming message.
	rentalId?: string,
): void {
	const dispatch = useDispatch()

	useEffect(() => {
		if (!dealId) return
		const socket = getRealtimeSocket()

		void socket.emit('deal.subscribe', { dealId })

		const invalidate = (event: DealMessageEvent) => {
			if (event.dealId !== dealId) return
			dispatch(
				dealMessagesApi.util.invalidateTags([
					{ type: 'DealMessage', id: dealId }
				])
			)
			if (rentalId) {
				dispatch(
					rentalMessagesApi.util.invalidateTags([
						{ type: 'RentalMessage', id: rentalId }
					])
				)
			}
		}

		socket.on('message.received', invalidate)
		socket.on('message.sent', invalidate)
		socket.on('message.failed', invalidate)

		return () => {
			socket.off('message.received', invalidate)
			socket.off('message.sent', invalidate)
			socket.off('message.failed', invalidate)
			socket.emit('deal.unsubscribe', { dealId })
		}
	}, [dealId, rentalId, dispatch])
}
